export default __webpack_public_path__ + "static/v1-1fb2b7d1507b54b5e266b650c1c68486.jpg";